import Paper from "@mui/material/Paper";
import { Header } from "./Headers/MainHeader/MainHeader";
import classes from "./Layout.module.css";
import MessageModal from "./Modals/MessageModal/MessageModal";
import SideBar from "./SideBar/SideBar";
import SideModal from "./Modals/SideModal/SideModal";
import TableModal from "./Modals/TableModal/TableModal";

const Layout = (props) => {
  var liClasses = [classes.pageContainer/*, props.dashboard !== undefined ? classes.dashboard : ''*/];

  return (
    <>
      <Paper elevation={8} className={liClasses.join(' ')}>
        {props.children}
      </Paper>
      <Header></Header>
      <SideBar className={classes.sideBar}></SideBar>
      <MessageModal/>
      <TableModal/>
      <SideModal/>
    </>
  );
};

export default Layout;
